module.exports = __webpack_public_path__ + "img/np_dashboard_3048219_000000.b9f28abf.svg";